module.exports = __webpack_public_path__ + "img/U1F44C.5f9bf2d8.png";